import {
    getBrowserLanguage,
    getBrowserTimeZone,
    getDeepLink,
} from "../../utils";
import { CreateRemoteBrowserResponse } from "@amzn/ermine-ssr-sdk/clients/ermineserversiderenderingservice";
import { AWSError } from "aws-sdk";
import log from "../../logging";
import { useMutation } from "@tanstack/react-query";
import { Cookies } from "webextension-polyfill";
import { isEmptyList } from "../../utils/commonUtils";
import { getErmineSsrClient } from "../../utils/ermineSsrClientUtil";
import {
    getFormattedAwsErrorMessage,
    isAWSError,
} from "../../utils/errorUtils";

export const useCreateRemoteBrowser = () => {
    const result = useMutation<
        CreateRemoteBrowserResponse,
        AWSError,
        { portalArn: string; cookies?: Cookies.Cookie[] }
    >({
        mutationFn: async ({ portalArn, cookies }) => {
            try {
                return await getErmineSsrClient()
                    .makeUnauthenticatedRequest("createRemoteBrowser", {
                        portalArn,
                        sessionConfig: {
                            supportedLanguage: getBrowserLanguage(),
                            timeZone: getBrowserTimeZone(),
                            deepLink: getDeepLink(),
                        },
                        cookies: isEmptyList(cookies)
                            ? null
                            : JSON.stringify(cookies),
                    })
                    .promise();
            } catch (err) {
                await log.error(
                    isAWSError(err)
                        ? getFormattedAwsErrorMessage(err, "OidcBrowserCreator")
                        : "Failed to create streaming endpoint"
                );
                throw err;
            }
        },
    });

    return result.mutateAsync;
};
